import React, { useState } from "react";
import PropTypes from "prop-types";
import * as editableDocument from "utils/model/editableDocument";
import flow from "lodash.flow";
import ScoringIndicatorListComponent from "./ScoringIndicatorListComponent";
import useEventCallback from "features/common/customHooks/useEventCallback";
import { collection } from "utils/immutable";
import { isMandatory, foreachProp } from "utils/simple-validations";
import { when, prop } from "utils/fn-combinators";

const getItemValidationRules = () => ({
  values: foreachProp(when(prop("isMandatory"), [isMandatory()]))
});

export const ScoringIndicatorListContainer = ({
  documentScoringGridId,
  indicatorList,
  disabled,
  periodList,
  dimensionPeriods
}) => {
  const [state, setState] = useState({
    showModal: false,
    loading: false,
    saving: false,
    localIndicatorList: indicatorList.map(editableDocument.create),
    localPeriodList: periodList
  });

  const handleFinancialIndicatorValueChange = useEventCallback(
    (idx, periodId, value) => {
      const indicatorToUpdate = state.localIndicatorList[idx];
      const values = {
        ...indicatorToUpdate.document.values,
        [periodId]: value === "" ? null : value
      };

      const updateAndValidateItem = flow(
        editableDocument.update("values", values, null),
        editableDocument.validate(getItemValidationRules(), false)
      );

      const localIndicatorList = collection.update(idx, updateAndValidateItem, state.localIndicatorList);

      setState({
        ...state,
        localIndicatorList
      });
    },
    [state]
  );

  const onOpenDimensionListModal = () => {
    setState({
      ...state,
      showModal: true
    });
  };

  const onCloseDimensionListModal = () => {
    setState({
      ...state,
      showModal: false
    });
  };
  const isValid = state.localIndicatorList.every(x => x.validationInfo.isValid);

  return (
    <ScoringIndicatorListComponent
      showModal={state.showModal}
      isValid={isValid}
      saving={state.saving}
      disabled={disabled}
      indicatorList={state.localIndicatorList || []}
      periodList={state.localPeriodList || []}
      onOpenDimensionListModal={onOpenDimensionListModal}
      onCloseDimensionListModal={onCloseDimensionListModal}
      handleFinancialIndicatorValueChange={handleFinancialIndicatorValueChange}
      documentScoringGridId={documentScoringGridId}
      dimensionPeriods={dimensionPeriods}
    />
  );
};

ScoringIndicatorListContainer.propTypes = {
  documentScoringGridId: PropTypes.number.isRequired,
  scoringClassificationId: PropTypes.number.isRequired,
  indicatorList: PropTypes.array.isRequired,
  periodList: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  dimensionPeriods: PropTypes.array.isRequired
};

export default ScoringIndicatorListContainer;
